import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../../../i18n";
import { MaterialIcon } from "./checkoutUi";

const PaymentSuccessView = ({ onComplete }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const timer = window.setTimeout(() => {
      if (onComplete) {
        onComplete();
      } else {
        navigate("/dashboard/client", { replace: true });
      }
    }, 3500);

    return () => window.clearTimeout(timer);
  }, [navigate, onComplete]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-primary/20 backdrop-blur-sm">
      <div className="flex max-w-md scale-100 flex-col items-center rounded-3xl bg-white p-12 text-center shadow-2xl transition-transform duration-500">
        <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-secondary-container text-secondary">
          <MaterialIcon name="check_circle" filled className="text-[48px]" />
        </div>
        <h3 className="mb-2 font-headline-xl text-headline-xl text-on-surface">
          {t("payment.paymentSuccessful")}
        </h3>
        <p className="mb-8 font-body-lg text-on-surface-variant">
          {t("payment.paymentSuccessBody")}
        </p>
        <div className="h-1 w-full overflow-hidden rounded-full bg-surface-container">
          <div className="checkout-progress-bar h-full bg-secondary" />
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccessView;
